module.exports = __webpack_public_path__ + "media/images/flags/si-e7d45ba2117721b82de316fd280a4798.svg";